import { createContext, useContext } from 'react';

/**
 * The build this page came from, e.g. "Build 412 · ac43237 · 10/01/2026 13:05 ET", in small
 * muted text at the foot of every screen. The app provides it once; each shell renders it.
 */
const BuildInfoContext = createContext<string | null>(null);

export const BuildInfoProvider = BuildInfoContext.Provider;

export function BuildStamp() {
  const text = useContext(BuildInfoContext);
  if (!text) return null;
  return <footer className="build-stamp">{text}</footer>;
}
